import { BarChart, Tag } from "assets/icons";
import { SelectField } from "components/form/fields";
import { FC } from "react";
import { IFieldType, IOption } from "types";

interface Props {
  themaOptions: IOption[];
  difficultyOptions: IOption[];
  setThema: (thema: string | null) => void;
  setDifficulty: (difficulty: string | null) => void;
}

export const TableFilters: FC<Props> = ({
  themaOptions = [],
  difficultyOptions = [],
  setThema,
  setDifficulty,
}) => {
  return (
    <div className="table-overview-filters">
      <SelectField
        options={themaOptions}
        placeholder="Thema"
        prefixText="Ik zoek een tussendoortje over"
        hideLabel
        type={IFieldType.select}
        labelIcon={<Tag />}
        name="Thema"
        label="Thema"
        className="table-overview-filters__thema"
        onChange={({ currentTarget: { value } }) => setThema(value)}
      />
      <SelectField
        options={difficultyOptions}
        prefixText="met"
        placeholder="Moeilijkheidsgraad"
        hideLabel
        type={IFieldType.select}
        labelIcon={<BarChart />}
        name="Moeilijkheidsgraad"
        label="Moeilijkheidsgraad"
        className="table-overview-filters__difficulty"
        onChange={({ currentTarget: { value } }) => setDifficulty(value)}
      />
    </div>
  );
};
